import { useEffect, useState } from "react";
import styled from "styled-components";
import { Spacer } from "../Spacer";
import { SideBarIcon } from "./SideBarIcon";
import { SideBarItem } from "./SideBarItem";

import {
  LogoutOutlined,
  // SettingsSuggestOutlined,
} from "../../materialUi/materialUi";

import { SideBarSectionTitle } from "./SideBarSectionTitle";
import { useTranslation } from "react-i18next";
import "../../../../i18n/i18n";

export interface SideBarProps {
  sections: {
    title: string;
    routes: Array<{
      route: string;
      iconSrc?: JSX.Element;
      title: string;
      newCreation?: boolean;
      isBeta?: boolean;
    }>;
  }[];
  selectedRoute?: string;
  onChangeRoute: (route: string) => void;
  logout: () => void;
  companies: { name: string; uuid: string }[];
  currentCompany: string;
  onChangeCompany: (companyUuid: string) => void;
  onClickCompanyCreation: () => void;
  hasAnalyticsAccess: boolean;
  hasAdvancedAnalyticsAccess: boolean;
  canOrderBadges: boolean;
  isInProduction?: boolean;
  isInDemo?: boolean;
  canCreateCompany: boolean;
  children?: string | JSX.Element | JSX.Element[];
  hasGeolocationAccess: boolean;
}

interface StyledHeaderLogoProps {
  $sideBarSize: SideBarSize;
}

type SideBarSize = "S" | "L";

export const SideBar = (props: SideBarProps) => {
  const { t } = useTranslation();
  const [sideBarSize, setSideBarSize] = useState<SideBarSize>("L");
  const [selectedRoute, setSelectedRoute] = useState<string>(
    props.selectedRoute ?? "",
  );

  const onClickArrow = () => {
    sideBarSize === "S" ? setSideBarSize("L") : setSideBarSize("S");
  };

  const onClickLogo = () => {
    setSelectedRoute("");
    props.onChangeRoute("");
  };

  useEffect(() => {
    if (props.selectedRoute && props.selectedRoute !== selectedRoute) {
      setSelectedRoute(props.selectedRoute);
    }
  }, [props.selectedRoute, selectedRoute]);

  return (
    <StyledContainer $sideBarSize={sideBarSize}>
      <Spacer y={2} />
      <StyledTop>
        {props.children}
        <Spacer y={3} />
        <StyledSections>
          {props.sections.map((section) => {
            return (
              <StyledSection key={section.title}>
                <Spacer y={1} />
                <SideBarSectionTitle label={section.title} version="L" />
                <Spacer y={0.25} />
                {section.routes.map((route) => {
                  if (
                    !props.hasAdvancedAnalyticsAccess &&
                    route.route == "fleet"
                  )
                    return;
                  if (
                    !props.isInDemo &&
                    !props.hasGeolocationAccess &&
                    route.route === "geolocation"
                  )
                    return;

                  if (props.isInProduction && route.route === "departments") {
                    return;
                  }
                  return (
                    <StyledTop key={section.title + route.route}>
                      <SideBarItem
                        label={route.title}
                        icon={route.iconSrc}
                        version={sideBarSize}
                        onClick={() => {
                          setSelectedRoute(route.route);
                          props.onChangeRoute(route.route);
                        }}
                        isSelected={route.route === selectedRoute}
                        isNotification={route.newCreation || false}
                        isBeta={route.isBeta}
                      />
                    </StyledTop>
                  );
                })}
              </StyledSection>
            );
          })}
        </StyledSections>
      </StyledTop>
      <StyledBottom $sideBarSize={sideBarSize}>
        {/* <SideBarItem
          label={"menuOption.parameters"}
          icon={<SettingsSuggestOutlined />}
          version={sideBarSize}
          onClick={() => {
            props.onChangeRoute("users");
          }}
          isSelected={false}
          isNotification={false}
        /> */}
        <SideBarItem
          label={t("menuOption.logout")}
          icon={<LogoutOutlined />}
          version={sideBarSize}
          onClick={props.logout}
          isSelected={false}
          isNotification={false}
        />
        <Spacer y={0.5} />
        <StyledSideBarIcon>
          <SideBarIcon
            size={sideBarSize}
            onClickArrow={onClickArrow}
            onClickLogo={onClickLogo}
          />
        </StyledSideBarIcon>
      </StyledBottom>
      <Spacer y={2} />
    </StyledContainer>
  );
};
const StyledContainer = styled.div<StyledHeaderLogoProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: width 0.5s ease-out;
  padding: 0rem 1rem;
  width: ${({ $sideBarSize }) => ($sideBarSize === "L" ? "17.125rem" : "5rem")};
  height: 100%;
`;

const StyledTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const StyledBottom = styled.div<StyledHeaderLogoProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  min-height: ${({ $sideBarSize }) =>
    $sideBarSize === "L" ? "11rem" : "15rem"};
  width: 100%;
`;

const StyledSections = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  align-items: center;
  width: 100%;
`;

const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const StyledSideBarIcon = styled.div`
  width: 100%;
`;
